// Environment configuration
export const config = {
  // App information
  appName: import.meta.env.VITE_APP_NAME || 'DPP Softtag Manager',
  environment: import.meta.env.VITE_APP_ENV || 'dev',

  // API configuration
  formulaMateApiBaseUrl:
    'http://stm-code-agent-alb-1086655302.eu-west-1.elb.amazonaws.com',
  apiBaseUrl:
    import.meta.env.VITE_API_BASE_URL || 'http://dev.portal.dpp.yara.com/api',

  // Documentation / guideline links
  formulaGuidelineUrl:
    'https://yara.sharepoint.com/:b:/r/teams/DigitalProduction/Technology/00%20-%20Digital%20Production%20Platform/Digital%20Production%20User%20Manual/Soft%20Tag%20Manager%20User%20Guidelines/DPT-Soft%20Tag%20Creation%20-%20Formula%20Builder%20Guideline-200126-105247.pdf?csf=1&web=1&e=kPI8xg',

  // Documentation / guideline links
  softTagCreationGuidelineUrl:
    'https://yara.sharepoint.com/:b:/r/teams/DigitalProduction/Technology/00%20-%20Digital%20Production%20Platform/Digital%20Production%20User%20Manual/Soft%20Tag%20Manager%20User%20Guidelines/DPT-Soft%20Tag%20Creation%20Guideline%20(Soft%20Tag%20Details)-200126-105150.pdf?csf=1&web=1&e=xda9hQ',

  // Debug and logging
  isDebug: import.meta.env.VITE_APP_DEBUG === 'true',
  logLevel: import.meta.env.VITE_APP_LOG_LEVEL || 'info',

  // Environment flags
  isLocalhost: import.meta.env.MODE === 'localhost',
  isDevelopment: import.meta.env.MODE === 'development',
  isProduction: import.meta.env.MODE === 'production',
  isTest: import.meta.env.MODE === 'test',
} as const;

// Global constants (defined in vite.config.ts)
declare global {
  const __DEV__: boolean;
  const __PROD__: boolean;
  const __TEST__: boolean;
  const __LOCALHOST__: boolean;
}

export default config;
